


export   const workflowSteps = [
    {
      step: "01",
      title: "Registration",
      description:
        "Vendors and buyers create validated accounts with comprehensive profile information.",
      details:
        "Secure identity verification ensures a trusted marketplace environment.",
      image:
        "https://static.wixstatic.com/media/0dda38_738a610a37c14a2ea78ec930d36c7acc~mv2.png?originWidth=768&originHeight=576",
    },
    {
      step: "02",
      title: "Submission",
      description:
        "Buyers submit requirements in natural language. Vendors add detailed product specifications.",
      details:
        "Our AI engine parses complex requirements into structured data points.",
      image:
        "https://static.wixstatic.com/media/0dda38_86722b5633c74f3da6b1a74b0cc3627a~mv2.png?originWidth=768&originHeight=576",
    },
    {
      step: "03",
      title: "Matching",
      description:
        "AI analyzes requirements and automatically shortlists qualified vendors with email notifications.",
      details:
        "Real-time algorithmic matching connects supply with demand instantly.",
      image:
        "https://static.wixstatic.com/media/0dda38_f75d2e87cb444e5b837d1b3f64266066~mv2.png?originWidth=768&originHeight=576",
    },
  ];